import axios from "axios";
import { Toast } from "../../lib/helpers/helpers";
import Auth from "../../lib/middleware/auth";
import API_MAP from "../../services/uri";
import BASE_URL from "../api";
import { AUTH_FAILED, AUTH_PASSED, VERIFYUSER } from "../types";
import errorDispatcher from "./errorDispatcher";
import errorHandler from "./errorHandler";
import { fetchCoupleData } from "./wedding";

// useSelector / types
const setSignin = (action) => {
	return { type: "SIGNIN", payload: action };
};
const setSignup = (action) => {
	return { type: "SIGNUP", payload: action };
};

export const signin = (credentials) => async (dispatch) => {
	try {
		const response = await axios.post(
			`${BASE_URL}/users/sign-in`,
			credentials
		);
		const { hasError } = response.data;
		// console.log(response);
		if (hasError) {
			return errorDispatcher(response.data.errors, dispatch, AUTH_FAILED);
		} else {
			const { user, token } = response.data.data;
			Auth.setToken(token, user);
			Auth.setCurrency(user.currency);
			dispatch(setSignin(user));
			Auth.setExperience(user.current_experience);
			Toast.fire({
				icon: "success",
				title: `Login successful,
                Welcome back, ${user.firstname}`,
			});
			dispatch(fetchCoupleData);
			return true;
		}
	} catch (error) {
		console.log("Signin Error=====>", error);
		return errorDispatcher(error, dispatch, AUTH_FAILED);
	}
};

export const signup = (credentials) => async (dispatch) => {
	try {
		const response = await axios.post(
			`${BASE_URL}/users/sign-up`,
			credentials
		);
		const { hasError } = response.data;
		if (hasError) {
			// console.log(response);
			return errorDispatcher(response.data.errors, dispatch, AUTH_FAILED);
		} else {
			const { user, token } = response.data.data;
			Auth.setToken(token, user);
			dispatch(setSignup(user));
			return true;
		}
	} catch (error) {
		console.log("Signup Error=====>", error);
		return errorDispatcher(error, dispatch, AUTH_FAILED);
	}
};
export const verifyUser = (credentials) => async (dispatch) => {
	const { email, code } = credentials;
	try {
		const response = await axios.get(
			`${BASE_URL}/users/verify-email?email=${email}&code=${code}`
		);
		const { hasError } = response.data;
		if (hasError) {
			console.log(response);
			return errorDispatcher(response.data.errors, dispatch, AUTH_FAILED);
		} else {
			return dispatch({
				type: VERIFYUSER,
				message: response.data.data,
				title: response.data.message,
			});
		}
	} catch (error) {
		console.log("Verification Error=====>", error);
		return errorDispatcher(error, dispatch, AUTH_FAILED);
	}
};

export const forgotPassword = (credentials) => async (dispatch) => {
	try {
		const response = await axios.post(
			`${BASE_URL}/users/forgot-password`,
			credentials
		);
		console.log(response.data);
		const { hasError } = response.data;
		if (hasError) {
			return errorDispatcher(response.data.errors, dispatch, AUTH_FAILED);
		} else {
			return dispatch({
				type: AUTH_PASSED,
				message: response.data.data,
				title: response.data.message,
			});
		}
	} catch (error) {
		console.log("Verification Error=====>", error);
		return errorDispatcher(error, dispatch, AUTH_FAILED);
	}
};

export const resetPassword = (credentials) => async (dispatch) => {
	try {
		const response = await axios.post(
			`${BASE_URL}/users/forgot-password`,
			credentials
		);
		console.log(response.data);
		const { hasError } = response.data;
		if (hasError) {
			return errorDispatcher(response.data.errors, dispatch, AUTH_FAILED);
		} else {
			return dispatch({
				type: AUTH_PASSED,
				message: response.data.data,
				title: response.data.message,
			});
		}
	} catch (error) {
		console.log("Verification Error=====>", error);
		return errorDispatcher(error, dispatch, AUTH_FAILED);
	}
};

export const resendVerificationMail = (credentials) => async (dispatch) => {
	try {
		const response = await axios.post(
			`${BASE_URL}/users/resend-verification-email`,
			credentials
		);
		console.log(response.data);
		const { hasError } = response.data;
		if (hasError) {
			return errorDispatcher(response.data.errors, dispatch, AUTH_FAILED);
		} else {
			return dispatch({
				type: AUTH_PASSED,
				message: response.data.data,
				title: response.data.message,
			});
		}
	} catch (error) {
		console.log("Verification Error=====>", error);
		return errorDispatcher(error, dispatch, AUTH_FAILED);
	}
};

export const logoutUser = async () => {
	try {
		const response = await axios.post(`${API_MAP.userSignOut}`);
		console.log("Signout error res =====> \n", response);
		const { hasError } = response.data;
		if (hasError) {
			// errorHandler(errors);
			return;
		} else {
			return response.data;
		}
	} catch (error) {
		// return errorHandler(error);
	}
};

export const changePassword = async (credentials) => {
	const response = await axios.post(`${API_MAP.changePassword}`, credentials);
	return response;
};

export const changePin = async (credentials) => {
	const response = await axios.post(`${API_MAP.changePin}`, credentials);
	return response;
};

export const setPin = async (credentials) => {
	const response = await axios.post(`${API_MAP.setPin}`, credentials);
	return response;
};

export const forgotPin = async (credentials) => {
	const response = await axios.post(`${API_MAP.forgotPin}`, credentials);
	return response;
};

export const resetPin = async (credentials) => {
	const response = await axios.post(`${API_MAP.resetPin}`, credentials);
	return response;
};

export const viewUserProfile = async () => {
	try {
		const response = await axios.get(`${API_MAP.viewProfile}`);
		const { hasError } = response.data;
		if (hasError) {
			return;
		}
		// console.log("view user profile======>>>\n", response.data.data);
		Auth.setUser(response.data.data);
		return response.data.data;
	} catch (error) {
		return errorHandler(error);
	}
};

export const ratingFeedback = async (credentials) => {
	try {
		const response = await axios.post(
			`${API_MAP.ratingFeedback}`,
			credentials
		);
		const { hasError } = response.data;
		if (hasError) {
			return;
		}
		return response.data;
	} catch (error) {
		console.log("rating error", error);
	}
};
